import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import { store } from './index'
import { ReportFilesPostResponse, ReportFilesPostRequest } from '@/dtos/report-files/post'
import { ReportFileTaskStatusPutRequest, ReportFileTaskStatusPutResponse } from '@/dtos/report-files/put'
import { ReportFilesSearchPostRequest, ReportFilesSearchPostResponse } from '@/dtos/report-files/search/post'
import { reportFilesClient } from '@/clients/report-files-client'

@Module({ store, dynamic: true, namespaced: true, name: 'reports' })
class ReportFilesStore extends VuexModule {
  // 報告書アップロード
  private _postReportFilesResponse: ReportFilesPostResponse | null = null

  get postReportFilesResponse(): ReportFilesPostResponse | null {
    return this._postReportFilesResponse
  }

  @Mutation
  private SET_REPORT_FILES_RESPONSE(res: ReportFilesPostResponse | null) {
    this._postReportFilesResponse = res
  }

  @Action
  async postReportFiles(req: ReportFilesPostRequest): Promise<void> {
    const res = await reportFilesClient.postReportFiles(req)
    this.SET_REPORT_FILES_RESPONSE(res || null)
  }

  // 報告書一覧
  private _reportFilesSearchPostResponse: ReportFilesSearchPostResponse = new ReportFilesSearchPostResponse([])

  get reportFilesSearchPostResponse(): ReportFilesSearchPostResponse {
    return this._reportFilesSearchPostResponse
  }

  @Mutation
  private PUSH_REPORT_FILES(res: ReportFilesSearchPostResponse): void {
    this._reportFilesSearchPostResponse = res
  }

  @Action
  async fetchReportFiles(req: ReportFilesSearchPostRequest): Promise<void> {
    const res = await reportFilesClient.postReportFilesSearch(req)
    if (res) this.PUSH_REPORT_FILES(res)
  }

  @Action
  async updateReportFileTaskStatus(req: ReportFileTaskStatusPutRequest): Promise<ReportFileTaskStatusPutResponse | void> {
    return await reportFilesClient.putReportFileTaskStatus(req)
  }
}

export const reportFilesModule = getModule(ReportFilesStore)
